/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Art11Inputs */

const en__field__enum_teachingsubjects_subject_art11 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Art11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

const de__field__enum_teachingsubjects_subject_art11 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Art11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst`)
};

/**
* | output |
* | --- |
* | "Art" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Art11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_art11 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Art11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Art11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_art11(inputs)
	return de__field__enum_teachingsubjects_subject_art11(inputs)
});
export { _field__enum_teachingsubjects_subject_art11 as "_field__enum_teachingSubjects_SUBJECT_ART" }